import React, { useState } from 'react'
import Pdf from '../../../../../../Components/Icons/Pdf'
import Filter from '../../../../../../Components/Icons/Filter'
import CloseIcon from '../../../../../../Components/Icons/Close'
import { CancelButton, SubmitButton } from '../../../../../../Components/Utils/Buttons'
import { useFormik } from 'formik'
import axiosInstance from '../../../../../../Services/axiosCommon'

import FormikSelectTwo, { FormikSelectTwoSmall } from '../../../../../../Components/Utils/Select'
import { NuDate, NuDateSmall,  } from '../../../../../../Components/Utils/Input'
import UseDropDown from '../../../../../../Components/Hooks/useDropDown'
import NuDateFormat from '../../../../../../Components/Utils/NuDate'
import Xls from '../../../../../../Components/Icons/Xls'
import NuAmount from '../../../../../../Components/Utils/NuAmount'
import NewReportTable from '../../../../../../Components/Others/NewReportTable'
import UseFetchReportData from '../../../../../../Components/Hooks/useFetchReportData'
import DropDownAddMetaData from '../../../../../../Components/Utils/selectAddMetaData'
import useFetchMataData from '../../../../../../Components/Hooks/useFetchMataData'
import { Link } from 'react-router-dom'
import { DownloadPDF, DownloadXLXS } from '../../../../../../Components/Utils/Download'

function FireSuppressionReport() {
    const [showFilter,setShowFilter] = useState(false)
    // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
    const [filter, setFilter] = useState(false);
    
    const headers = [
      {
        title: "Ref.",
        width: "10%",
        field: "Ref",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Client",
        width: "10%",
        field: "Client",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Contract",
        width: "10%",
        field: "Contract",
        textAlign: "left",
        rowAlign: "left",
      },
      
      {
        title: "Collected On",
        width: "10%",
        field: "CollectedOn",
        textAlign: "left",
        rowAlign: "left",
        type: "date",
      },
      {
        title: "Delivered On",
        width: "10%",
        field: "DeliveredOn",
        textAlign: "left",
        rowAlign: "left",
        type: "date",
      },
      {
        title: "Status",
        width: "10%",
        field: "Status",
        textAlign: "left",
        rowAlign: "left",
      },
    ];

        const [filterProps, setFilterProps] = useState({
          status:"",
            
        });

        const [params, setParams] = useState({
            status:"",
            
        });

       const formik = useFormik({
         enableReinitialize: true,
         initialValues: filterProps,
         validateOnChange: false,
         validateOnBlur: false,
         onSubmit: async (value) => {
           setParams({
            status:value.status,
           
           })
           setTimeout(() => {
            setFilter(true)
            // closeFilterDialog();
           }, 1000);
         }
       }) 
       const {data,getData,dataLoading,total,other} = UseFetchReportData("/xlsx-report/filter-refilling-suppression",params)


       function closeFilterDialog(){
         setShowFilter(false)
         formik.resetForm()
         setFilter(false)
         setParams({
          status:"",
         
         })
       }





  

       const { value: status, getData: refstatus } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Status_FireExtinguisher"
      );
  return (
    <>
      <div className="w-full h-full overflow-y-auto">
         <div className="w-full   items-center gap-x-3">
                <div className='flex gap-x-2 justify-between items-center w-full'>
                  <p className=" font-semibold text-xs 2xl:text-sm  relative top-[-40px]">
                 Fire Suppression Report : {data?.length}
                  </p>

                    <form onSubmit={formik.handleSubmit}>
            <div className=' w-full grid grid-cols-3 gap-x-3'>
                              <NuDate
                                                              label="Delivered On"
                                                              placeholder="dd/mm/yyyy"
                                                              formik={formik}
                                                              name="DeliveredOn"
                                                              width="w-full"
                                                            />
                                                             <NuDate
                                                              label="Collected On"
                                                              placeholder="dd/mm/yyyy"
                                                              formik={formik}
                                                              name="CollectedOn"
                                                              width="w-full"
                                                            />
                             <FormikSelectTwo
              label="Status"
              Options={status}
              formik={formik}
              placeholder="Choose"
              name="status"

              width="w-full "
            />
              
            </div>
            <div className=" w-full flex justify-end mb-1.5">
                <div className=" w-full flex justify-end items-end gap-2">
                  <SubmitButton name="Apply" />
                  <CancelButton label='Clear'  handleClick={closeFilterDialog} />
                </div>
              </div>
            </form>
                  
                 <div className=" flex gap-4 justify-endrelative top-[-40px]">
                            <DownloadPDF url={`/xlsx-report/export-clients-pdf`} fileName="Fire Suppression Report" params={params} />
                            <DownloadXLXS url={`/xlsx-report/export-refilling-suppression`} fileName="Fire Suppression Report" params={params} />
                            </div>
                  </div>
        

       

        </div>
        <NewReportTable headers={headers} data={data} dataLoading={dataLoading} />

      </div>
    </>
  );
}

export default FireSuppressionReport